'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Validator2 = require('./Validator');

var _Validator3 = _interopRequireDefault(_Validator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var reverse = function reverse(promise) {
  return new Promise(function (resolve, reject) {
    return Promise.resolve(promise).then(reject, resolve);
  });
};

var promiseAny = function promiseAny(iterable) {
  return reverse(Promise.all([].concat(_toConsumableArray(iterable)).map(reverse)));
};

var MultiValidator = function (_Validator) {
  _inherits(MultiValidator, _Validator);

  function MultiValidator(_ref) {
    var validators = _ref.validators,
        isAny = _ref.isAny;

    _classCallCheck(this, MultiValidator);

    var _this = _possibleConstructorReturn(this, (MultiValidator.__proto__ || Object.getPrototypeOf(MultiValidator)).call(this));

    _this.validators = validators || [];
    _this.isAny = isAny || false;
    return _this;
  }

  _createClass(MultiValidator, [{
    key: 'validate',
    value: function validate(value, attribute, model) {
      if (!this.validators.length) return Promise.resolve();

      var jobs = this.validators.map(function (validator) {
        return validator.validate(value, attribute, model);
      });

      return this.isAny ? promiseAny(jobs).then(function (messages) {
        return messages.find(function (i) {
          return i;
        }) || null;
      }) : Promise.all(jobs).then(function (messages) {
        return messages.find(function (i) {
          return i;
        }) || null;
      });
    }
  }, {
    key: 'isSafe',
    value: function isSafe() {
      if (this.validators.length) {
        var unsafeValidators = this.validators.filter(function (v) {
          return !v.isSafe();
        });

        return !unsafeValidators.length;
      }

      return false;
    }
  }]);

  return MultiValidator;
}(_Validator3.default);

exports.default = MultiValidator;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/validators/MultiValidator.js
// module id = 769
// module chunks = 0